module.exports = __webpack_public_path__ + "img/table.6ec27c57.jpg";